import { getCurrentInstance } from 'vue';

import { useFieldLabelsV2 } from './useFieldLabelsV2';
import { useFieldLabelsV3 } from './useFieldLabelsV3';

export function useFieldLabels(fieldType) {
    const instance = getCurrentInstance();
    const fieldV3Account = instance.proxy.$store.getters['user/fieldV3Account'];
    return fieldV3Account
        ? useFieldLabelsV3(fieldType)
        : useFieldLabelsV2(fieldType);
}
